import React from 'react';
import { isEventLeadsEnabled } from '../../../../../data/filters/leads/isEventLeadsEnabled';
import Link from '../../../Link';
import Icon from '../../../icons/Icon';

function LeadScanIcon(props) {
    const { event, isActive } = props;

    if (!isEventLeadsEnabled(event)) return null;

    return (
        <Link href={['/events', event.id, 'leads'].join('/')}>
            <Icon className="lead-scan" selected={isActive} />
        </Link>
    );
}

export default LeadScanIcon;
